'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const isUrlValid = (userInput) => {
  const res = userInput.match(
    /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
  );
  if (!res)
    return false;
  else
    return true;
};

exports.isUrlValid = isUrlValid;
